import React from 'react';

import { useLoaderProviderContext, OtherKeys } from '@common/react/components/Core/LoaderProvider/LoaderProvider';

interface Props {
	defaultLoader?: JSX.Element;
	className?: string;
	type?: OtherKeys;
}

const Loader: React.FC<Props> = (props: Props) => {
	const {
		defaultLoader,
		className = null,
		type = 'pageLoader',
	} = props;
	const loaderContext = useLoaderProviderContext();

	const getLoader = () =>
		loaderContext?.state?.loaders?.[type] || loaderContext?.state?.loaders?.pageLoader || defaultLoader || '';

	if (className != null) {
		return <div className={className}>
			{getLoader()}
		</div>;
	}

	return <>
		{getLoader()}
	</>;
};

export default Loader;
